import moment from 'moment-timezone';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useApi from '../useApis';
import { useDispatch } from 'react-redux';
import { setClinicSlots } from '../Store/commonSlice';
import { slotsFormatter } from '../Helpers';
import { setAppointmentList } from '../Store/commonSlice';
import { setTodayAppointment, setTotalCount } from '../Store/todayAppointmentSlice';
let doctorClinicId = null;
const useAppointment = () => {
  const userData = useSelector((state) => state?.authReducer);
  if (userData?.clinicData?.[0]) doctorClinicId = userData?.clinicData?.[0]?.doctorClinicId ?? 0;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [appointments, setAppointments] = useState([]);

  const [respectiveSlots, setRespectiveSlots] = useState({});
  const [slotsIndicator, setSlotsIndicator] = useState('');
  // const [totalCount, setTotalCount] = useState(0);
  const api = useApi();
  //This api provides listing of Patients

  const timezone = 'Asia/Karachi'; // Replace with your timezone
  // Get the current date in the same timezone
  const today = moment.tz(timezone).startOf('day');
  // Parse the datetime and convert it to the specified timezone

  const getAllAppointments = async (params) => {
    setLoading(true);
    const response = await api?.getAllAppointments(params);
    if (response?.data?.headers?.code === 200) {
      //transform appointemnt data
      const transformedData = response?.data?.body?.map((data) => {
        let bgColor = '';
        if (data?.isDeleted) {
          bgColor = 'var(--red-color)';
        } else if (!moment.tz(data?.appointmentEndDateTime, timezone).isAfter(today)) {
          bgColor = 'var(--slate-gray)';
        } else if (data?.isAppointment) {
          bgColor = 'var(--sky-blue)';
        } else if (!data?.isAppointment) {
          bgColor = '#4A3AFF';
        }
        return {
          title: data?.patient?.patientName,
          // .appointmentStartDateTime
          start: moment(data?.appointmentStartDateTime).format('YYYY-MM-DD'),
          end: moment(data?.appointmentEndDateTime).format('YYYY-MM-DD'),
          // backgroundColor: moment.tz(data?.appointmentEndDateTime, timezone).isAfter(today)
          //   ? data?.isAppointment
          //     ? '#4A3AFF'
          //     : 'var(--sky-blue)'
          //   : 'var(--red-color)',

          backgroundColor: bgColor,
          textColor: '#fff',
          ...data
        };
      });
      dispatch(setAppointmentList(transformedData));
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const addAppointment = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.addAppointment(params);
    if (response?.data?.headers?.code === 200) {
      getAllAppointments({
        startDateTime: '2024-01-01T00:00:00.000Z',
        endDateTime: '2028-12-31T23:59:59.999Z'
      });
      if (typeof onSuccess === 'function') onSuccess();
      toast.success('Appointment added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const addDoctorTime = async (params, onSuccess) => {
    const response = await api?.addDoctorTime(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
      toast.success('Add Doctor time successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const editAppointment = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.editAppointment(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      getAllAppointments({
        startDateTime: '2024-01-01T00:00:00.000Z',
        endDateTime: '2028-12-31T23:59:59.999Z'
      });
      if (typeof onSuccess === 'function') onSuccess();
      toast.success('Appointment Reschedule successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const moveToQueue = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.moveToQueue(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      if (typeof onSuccess === 'function') onSuccess();
      toast.success('Patient Add to Queue Successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const getAppointmentSlots = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.getAppointmentSlots(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      if (typeof onSuccess === 'function') onSuccess();
      if (response?.data?.body?.appointmentSlotMsg === 'Success') {
        const availableTimeSlots = response?.data?.body?.availableTimeSlots;
        setRespectiveSlots(slotsFormatter(availableTimeSlots));
        setSlotsIndicator('');
      } else {
        setSlotsIndicator(response?.data?.body?.appointmentSlotMsg);
        toast.error(response?.data?.body?.appointmentSlotMsg);
      }

      // dispatch(setClinicSlots)
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const cancelAppointment = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.cancelAppointment(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      // if (!filter) {
      //   getAllAppointments({
      //     startDateTime: '2024-01-01T00:00:00.000Z',
      //     endDateTime: '2028-12-31T23:59:59.999Z'
      //   });
      // }

      if (typeof onSuccess === 'function') onSuccess();
      toast.success(`The Appointment of ${params?.patientName} is cancelled`);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const sendReminderSms = async (params, onSuccess) => {
    const response = await api?.sendReminderSms(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      if (typeof onSuccess === 'function') onSuccess();
      return response;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const registerAndAddAppointment = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.registerAndAppointment(params, onSuccess);
    if (response?.data?.headers?.code === 200) {
      toast.success('Patient Added successfully');
      if (typeof onSuccess === 'function') onSuccess();
      return response;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const getAppointmentList = async (pageNumber = 1, filter = null) => {
    const response = await api?.getAppointmentList({
      pageNumber: pageNumber ? pageNumber : 1,
      pageSize: 10,
      totalRowsCount: 0,
      sortField: '',
      sortDirection: '',
      search: '',
      filter: {
        doctorClinicId: userData?.clinicData[0]?.doctorClinicId,
        ...filter
      }
    });

    if (response?.data?.headers?.code === 200) {
      dispatch(setTodayAppointment(response?.data?.body?.data?.appointments));
      dispatch(setTotalCount(response?.data?.body?.pagination?.totalRowsCount));
      // setTotalCount(response?.data?.body?.pagination?.totalRowsCount);
      setLoading(false);
      return response?.data?.body;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const sendBulkAppointmentReminder = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.sendBulkAppointmentReminder({ ...params, doctorClinicId });
    if (response?.data?.headers?.code === 200) {
      toast.success('send sms to all patient successfully');
      if (typeof onSuccess === 'function') onSuccess();
      setLoading(false);
      return response;
    } else {
      toast.error(response?.data?.headers?.msg || 'Invalid');
    }
    setLoading(false);
  };
  return {
    loading,
    addDoctorTime,
    getAllAppointments,
    addAppointment,
    editAppointment,
    slotsIndicator,
    moveToQueue,
    getAppointmentSlots,
    respectiveSlots,
    cancelAppointment,
    setSlotsIndicator,
    sendReminderSms,
    registerAndAddAppointment,
    getAppointmentList,
    sendBulkAppointmentReminder
  };
};

export default useAppointment;
